if (window.CSS && window.CSS.supports('color', 'var(--supports-css-vars)')) {
  const element = document.createElement('style');
  document.head.appendChild(element);

  if (element.sheet) {
    const { sheet } = element;

    let currentInitialInnerHeight = false;
    let currentMinInnerHeight = false;
    let currentMaxInnerHeight = false;
    let currentInnerHeight = false;
    let currentOrientation = false;
    let currentRule = false;

    const updateInnerHeight = function updateInnerHeight() {
      const orientation = Math.round(window.orientation ? window.orientation : 0);
      if (currentOrientation === false || currentOrientation !== Math.abs(orientation)) {
        currentOrientation = Math.abs(orientation);
        currentInitialInnerHeight = false;
        currentMinInnerHeight = false;
        currentMaxInnerHeight = false;
        currentInnerHeight = false;
      }

      const innerHeight = Math.round(window.innerHeight ? window.innerHeight : 0);
      if (currentInnerHeight === false || currentInnerHeight !== innerHeight) {
        currentInnerHeight = innerHeight;
        if (currentInitialInnerHeight === false) {
          currentInitialInnerHeight = currentInnerHeight;
        }
        if (currentMinInnerHeight === false || currentInnerHeight < currentMinInnerHeight) {
          currentMinInnerHeight = currentInnerHeight;
        }
        if (currentMaxInnerHeight === false || currentInnerHeight > currentMaxInnerHeight) {
          currentMaxInnerHeight = currentInnerHeight;
        }

        const rule = `:root { --inner-height: ${currentInnerHeight}px; --inner-height-initial: ${currentInitialInnerHeight}px; --inner-height-min: ${currentMinInnerHeight}px; --inner-height-max: ${currentMaxInnerHeight}px; }`;
        if (currentRule === false || currentRule !== rule) {
          currentRule = rule;

          let ruleIndex = -1;
          for (let i = 0; i < sheet.cssRules.length; i += 1) {
            const { cssText } = sheet.cssRules[i];
            if (cssText && cssText.indexOf('--inner-height:') !== -1) {
              ruleIndex = i;
              break;
            }
          }

          sheet.insertRule(rule, sheet.cssRules.length);
          if (ruleIndex !== -1) {
            sheet.deleteRule(ruleIndex);
          }
        }
      }
    };

    let passiveSupported = false;
    try {
      const options = {
        // This function will be called when the browser attempts to access the passive property.
        get passive() {
          passiveSupported = true;
          return undefined;
        },
      };
      window.addEventListener('testPassive', null, options);
      window.removeEventListener('testPassive', null, options);
    } catch (ignored) {
      passiveSupported = false;
    }

    let updateInnerHeightDebouncing = false;
    const updateInnerHeightDebounce = () => {
      if (!updateInnerHeightDebouncing) {
        updateInnerHeightDebouncing = true;
        window.requestAnimationFrame(() => {
          updateInnerHeight();
          updateInnerHeightDebouncing = false;
        });
      }
    };
    window.addEventListener('resize', updateInnerHeightDebounce, passiveSupported ? { passive: true } : false);
    window.addEventListener('orientationchange', updateInnerHeightDebounce, passiveSupported ? { passive: true } : false);
    window.addEventListener('scroll', updateInnerHeightDebounce, passiveSupported ? { passive: true } : false);
    updateInnerHeightDebounce();
  } else {
    document.head.removeChild(element);
  }
}
